<template>
  <div class="wrap">
    <!-- 顶部标题 -->
    <div class="header_title">
      <div class="header_center">
        <div class="title">
          申报奖项:
          <span>{{ $route.query.title }}</span>
        </div>
        <div class="back_page" @click="backpage">返回上一页</div>
      </div>
    </div>
    <!-- 表单盒子，左边的导航栏nav_left,右边的表单form_rightform_right -->
    <div class="form_box">
      <div class="nav_left">
        <div class="nav_title">需填写表单申报表</div>
        <div class="nav_list">
          <!-- 导航栏列表 -->
          <div class="list" v-for="(item, index) in lefttitlelist" @click="scrollleft(item.name, item.id)" :key="index">
            <img class="tips" v-if="item.isok" src="../assets/6598@2x.png" alt />
            <img class="tips" v-else src="../assets/6668@2x.png" alt />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="preview">
          <!-- 左边三个按钮 -->
          <el-button v-if="rId == 0" class="preservation" icon="el-icon-folder-opened" :plain="true"
            :loading="btnSaveStatus" v-btn-control="SaveDraftleft">保存草稿</el-button>
          <el-button v-if="rId == 0" class="online" icon="el-icon-view" :plain="true" @click="printPdf">在线预览</el-button>
          <div class="sumbit" :class="issumbitshow ? 'blue' : ''" v-btn-control="sumbit">
            <img src="../assets/19178@2x.png" alt />
            <p>提交平台审核</p>
          </div>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '省优工程“黄果树杯”'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="Contractorinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="承建单位（申报单位）简况" :background="Contractorinfo.Tipsbackground" :border="Contractorinfo.Tipsborder"
            :states="Contractorinfo.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.projectNname" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">推荐单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.RecommendedUnit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">申报单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.ReportingUnit" />
              </div>
            </div>

            <div class="my_form">
              <div class="form_title" style="height: 62px">填报日期</div>
              <div class="form_content">
                <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                  v-model="parameters.Contractorinfo.Filling_date" class="inpyabeb"></el-date-picker>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">承建单位信息</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.Contractor_name1" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">通信地址</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.mailing_address1" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone11" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.Postal1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                主营范围及其资质等级
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Contractorinfo.Qualification_level1"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 188px; text-align: center">
                承建内容
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Contractorinfo.Construction_content1"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                承建单位简介(500字以内)
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Contractorinfo.brief_introduction1"></textarea>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">法定代表人信息</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name21" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone21" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">申报工作联系人</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name31" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工作部门</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.work_department1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.postion1" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">固定电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.guding_phone1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">移动电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.movephone11" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">项目经理</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name41" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">持证等级</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.leave1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone31" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" v-for="(item, index) in parameters.unitinfo" :key="index" :id="'index' + index">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips :title="`参建单位信息${index == 0 ? '' : index}`" :delete_form="true" @deleteform="deleteform"
            :background="Informationparticipatingunits.Tipsbackground"
            :border="Informationparticipatingunits.Tipsborder" :states="Informationparticipatingunits.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">单位名称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].unitname" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">通信地址</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phoneaddress" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].codeyouzheng" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].Telephone" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                主营范围及其资质等级
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Qualification_level"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 188px; text-align: center">
                参建内容
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Construction_content"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参建工作量
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Construction_workload"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">参建比例</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].Construction_proportion" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参建单位简介(200字以内)
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].brief_introduction"></textarea>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">法定代表人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name2" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phone2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">申报工作联系人</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name3" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">工作部门</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].work_department" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].postion" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">固定电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].guding_phone" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">移动电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].movephone1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">项目经理</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name4" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">持证等级</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].leave" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phone3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form_1" >
          <Tips
            title="参建单位信息1"
            background="#FEF8EF"
            border="#FFB700"
            :states="false"
            :delete_form="true"
            @deleteform="deleteform"
          ></Tips>
          <div class="form_box_content">
            <MyForm class="my_form2" title="承建单位名称" :long="true" v-model="parameters.Contractor_name"></MyForm>
            <MyForm class="my_form" title="通信地址" :long="true" v-model="parameters.mailing_address"></MyForm>
            <MyForm class="my_form2" title="联系电话" title2="邮政编码" :text="true" :small="true" v-model="parameters.Postal_phone"></MyForm>
            <MyForm class="my_form" title="主营范围及其资质等级" :left_height="188" :textarea="true" v-model="parameters.Qualification_level"></MyForm>
            <MyForm class="my_form2" title="承建内容" :left_height="188" :textarea="true" v-model="parameters.Construction_content"></MyForm>
            <MyForm class="my_form" title="承建单位简介(500字以内)" :left_height="188" :textarea="true" v-model="parameters.brief_introduction"></MyForm>
            <div class="form_title">
              <p>法定代表人信息</p>
            </div>
            <MyForm class="my_form2" title="姓名" title2="联系电话" :text="true" :small="true" v-model="parameters.phone_name1"></MyForm>
            <div class="form_title">
              <p>申报工作联系人</p>
            </div>
            <MyForm class="my_form" title="姓名" title2="工作部门" :text="true" :small="true" v-model="parameters.work_name"></MyForm>
            <MyForm class="my_form2" title="职务" title2="固定电话" :text="true" :small="true" v-model="parameters.phone_postion"></MyForm>
            <MyForm class="my_form" title="移动电话" :title2="false" :text="true" :small="true" v-model="parameters.movephone1"></MyForm>
            <div class="form_title">
              <p>项目经理</p>
            </div>
            <MyForm class="my_form2" title="姓名" title2="持证等级" :text="true" :small="true" v-model="parameters.name_leave"></MyForm>
            <MyForm class="my_form" title="联系电话" :title2="false" :text="true" :small="true" v-model="parameters.movephone2"></MyForm>
          </div>
        </div>-->
        <div class="form_1">
          <div class="newlybuild" @click="addnew">
            <img src="../assets/6622@2x.png" alt />
            <p>新增参建单位信息表</p>
          </div>
        </div>
        <div class="form_1" id="ProjectOverview">
          <Tips title="申报工程概况" :background="ProjectOverview.Tipsbackground" :border="ProjectOverview.Tipsborder"
            :states="ProjectOverview.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.projectNname" />
              </div>
            </div>

            <div class="my_form">
              <div class="form_title" style="height: 62px">建设地点</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.Construction_site" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工程类别</div>
                <div class="form_content">
                  <el-select v-model="parameters.ProjectOverview.workscategory" placeholder="请选择企业性质" class="inpyabeb"
                    size="small">
                    <el-option label="住宅工程" value="住宅工程"></el-option>
                    <el-option label="公共建筑工程" value="公共建筑工程"></el-option>
                    <el-option label="工业交通水利工程" value="工业交通水利工程"></el-option>
                    <el-option label="市政园林工程" value="市政园林工程"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">使用功能</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.functi" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">建设规模</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.build" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">结构类型</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.structure" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">申报范围</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.declare" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工程合同额</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.engineering" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">开工时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.worktime" class="inpyabeb"></el-date-picker>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">竣工时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.becompleted" class="inpyabeb"></el-date-picker>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">验收时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.acceptance" class="inpyabeb"></el-date-picker>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">验收单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.acceptance_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">勘察单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.survey_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">建设单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.Construction_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">使用单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.User_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">设计单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.Design_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">监理单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.control_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程简介（800字以内）
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.ProjectOverview.project_info"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Explain_the_reason">
          <Tips title="申报理由" :background="
            parameters.Explain_the_reason != '' ? '#EDF8F5' : '#FEF8EF'
          " :border="
  parameters.Explain_the_reason != '' ? '#1ABF98' : '#FFB700'
" :states="parameters.Explain_the_reason == '' ? false : true"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参照申报条件阐述理由
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Explain_the_reason"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Explain_the_opinion">
          <Tips title="有关单位意见"></Tips>
          <div class="form_box_content" style="text-align: left;color:red;">
            有关单位意见请线下填写
          </div>
        </div>
        <div class="form_1" id="SupplementaryContent">
          <Tips title="申报登记表需补充内容" :background="SupplementaryContent.Tipsbackground"
            :border="SupplementaryContent.Tipsborder" :states="SupplementaryContent.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">申报联系人邮箱</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.Contactemail" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  推荐单位联系人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.Unitcontact" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.contactnumber" />
                  </div>
                </div>
              </div>
            </div>
            <MyForm class="my_form" title="工程立项复批" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('1', value)"
              :filechangelist="parameters.SupplementaryContent.is1arr"
              :isuploadisshow="parameters.SupplementaryContent.is1"></MyForm>
            <MyForm class="my_form2" title="土地使用证" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('2', value)"
              :filechangelist="parameters.SupplementaryContent.is2arr"
              :isuploadisshow="parameters.SupplementaryContent.is2"></MyForm>
            <MyForm class="my_form" title="建设工程规划许可证" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('3', value)"
              :filechangelist="parameters.SupplementaryContent.is3arr"
              :isuploadisshow="parameters.SupplementaryContent.is3"></MyForm>
            <MyForm class="my_form2" title="工程创优策划书" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('4', value)"
              :filechangelist="parameters.SupplementaryContent.is4arr"
              :isuploadisshow="parameters.SupplementaryContent.is4"></MyForm>
            <MyForm class="my_form" title="工程施工图设计文件审查合格书或审批文件(电力工程按行业规定)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('5', value)"
              :filechangelist="parameters.SupplementaryContent.is5arr"
              :isuploadisshow="parameters.SupplementaryContent.is5"></MyForm>
            <MyForm class="my_form2" title="工程施工合同" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('6', value)"
              :filechangelist="parameters.SupplementaryContent.is6arr"
              :isuploadisshow="parameters.SupplementaryContent.is6"></MyForm>
            <MyForm class="my_form" title="施工许可证或批准开工报告" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('7', value)"
              :filechangelist="parameters.SupplementaryContent.is7arr"
              :isuploadisshow="parameters.SupplementaryContent.is7"></MyForm>
            <MyForm class="my_form2" title="建设工程消防验收意见书(涉及消防工程)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('8', value)"
              :filechangelist="parameters.SupplementaryContent.is8arr"
              :isuploadisshow="parameters.SupplementaryContent.is8"></MyForm>
            <MyForm class="my_form" title="工程“竣工验收报告”(交通工程提交“交工验收证书”,电力工程提交“投运备案证明书”,水利工程提交“工程合同完工验收文件”)"
              :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('9', value)"
              :filechangelist="parameters.SupplementaryContent.is9arr"
              :isuploadisshow="parameters.SupplementaryContent.is9"></MyForm>
            <MyForm class="my_form2" title="“投入使用时间和使用效果证明”(建设单位出具)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('10', value)"
              :filechangelist="parameters.SupplementaryContent.is10arr"
              :isuploadisshow="parameters.SupplementaryContent.is10"></MyForm>
            <MyForm class="my_form" title="“建筑业10项新技术应用证明”(监理单位出具)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('11', value)"
              :filechangelist="parameters.SupplementaryContent.is11arr"
              :isuploadisshow="parameters.SupplementaryContent.is11"></MyForm>
            <MyForm class="my_form2" title="工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”(建设单位出具)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('12', value)"
              :filechangelist="parameters.SupplementaryContent.is12arr"
              :isuploadisshow="parameters.SupplementaryContent.is12"></MyForm>
            <MyForm class="my_form" title="建筑业新技术应用示范工程或绿色施工示范工程证书" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('13', value)"
              :filechangelist="parameters.SupplementaryContent.is13arr"
              :isuploadisshow="parameters.SupplementaryContent.is13"></MyForm>
            <MyForm class="my_form2" title="“贵州省建筑工程优质质量结构工程”评定文件(住宅工程、公共建筑工程、市政桥梁)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('14', value)"
              :filechangelist="parameters.SupplementaryContent.is14arr"
              :isuploadisshow="parameters.SupplementaryContent.is14"></MyForm>
            <MyForm class="my_form" title="“贵州省建筑安全文明施工样板工地”评定文件(住宅工程、公共建筑工程、市政园林工程)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('15', value)"
              :filechangelist="parameters.SupplementaryContent.is15arr"
              :isuploadisshow="parameters.SupplementaryContent.is15"></MyForm>
            <MyForm class="my_form2" title="无质量安全事故承诺" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('16', value)"
              :filechangelist="parameters.SupplementaryContent.is16arr"
              :isuploadisshow="parameters.SupplementaryContent.is16"></MyForm>
            <!--              <MyForm-->
            <!--                  class="my_form2"-->
            <!--                  title="无质量安全事故承诺补充材料"-->
            <!--                  :certificatePdf="true"-->
            <!--                  :left_height="100"-->
            <!--                  @filechange="filechange"-->
            <!--                  @isuploadshow="(value) => isuploadshow('17', value)"-->
            <!--                  :filechangelist="parameters.SupplementaryContent.is17arr"-->
            <!--                  :isuploadisshow="parameters.SupplementaryContent.is17"-->
            <!--              ></MyForm>-->
            <MyForm class="my_form2" title="无拖欠农民工工资承诺" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('18', value)"
              :filechangelist="parameters.SupplementaryContent.is18arr"
              :isuploadisshow="parameters.SupplementaryContent.is18"></MyForm>
            <!--              <MyForm-->
            <!--                  class="my_form"-->
            <!--                  title="无拖欠农民工工资承诺补充材料"-->
            <!--                  :certificatePdf="true"-->
            <!--                  :left_height="100"-->
            <!--                  @filechange="filechange"-->
            <!--                  @isuploadshow="(value) => isuploadshow('19', value)"-->
            <!--                  :filechangelist="parameters.SupplementaryContent.is19arr"-->
            <!--                  :isuploadisshow="parameters.SupplementaryContent.is19"-->
            <!--              ></MyForm>-->
            <MyForm class="my_form2" title="反映工程概况和质量状况的彩色照片15张" :certificatefour="true" :left_height="100"
              @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('20', value)"
              :filechangelist="parameters.SupplementaryContent.is20arr"
              :isuploadisshow="parameters.SupplementaryContent.is20"></MyForm>
            <MyForm class="my_form" title="5分钟工程影像资料" :certificatethree="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('21', value)"
              :filechangelist="parameters.SupplementaryContent.is21arr"
              :isuploadisshow="parameters.SupplementaryContent.is21"></MyForm>
            <MyForm class="my_form2" title="贵州省“黄果树杯”优质工程申报表（盖章后扫描件）" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('22', value)"
              :filechangelist="parameters.SupplementaryContent.is22arr"
              :isuploadisshow="parameters.SupplementaryContent.is22"></MyForm>
            <!-- 备注
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                备注
          </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters.remarks"
                ></textarea>
              </div>
            </div> -->
          </div>
        </div>
        <div class="form_1" id="DeclarationSummary">
          <Tips title="申报汇总表需补充内容" :background="DeclarationSummary.Tipsbackground"
            :border="DeclarationSummary.Tipsborder" :states="DeclarationSummary.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  承建单位工程技术负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Technicaldirector" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  参建单位工程技术负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.engineering" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  建设单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Construction_unit" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  设计单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Design_unit" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">质量监督单位</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.supervisionunit" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  质量监督单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Principaloftheunit" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  监理单位总监工程师
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Chiefengineer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="form_1" id="Recommendationform">-->
        <!--          <Tips-->
        <!--            title="推荐表"-->
        <!--            :background="Recommendationform? '#EDF8F5' : '#FEF8EF'"-->
        <!--            :border="Recommendationform? '#1ABF98' : '#FFB700'"-->
        <!--            :states="Recommendationform"-->
        <!--          ></Tips>-->
        <!--          <div class="form_box_content">-->
        <!--            <MyForm-->
        <!--              class="my_form2"-->
        <!--              :left_height="100"-->
        <!--              title="优质工程推荐表(按类型选择表格下载填写后上传)"-->
        <!--              :isDowninpu="true"-->
        <!--              @onChange2="onChange2"-->
        <!--              :wordfile="parameters.Recommendationform"-->
        <!--            ></MyForm>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- <div class="form_1">
          <Tips
            title="有关单位意见"
            background="#FEF8EF"
            border="#FFB700"
            :states="false"
          ></Tips>
          <div class="form_box_content">
            <div class="form_title">
              <p>建设单位意见</p>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                意见综述
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters.Opinion_summary"
                ></textarea>
              </div>
            </div>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.isOpinion_summary"
              ></MyForm>
              <MyForm
                class="my_form"
                title="建设单位主要负责人"
                :text="true"
                :small="true"
                v-model="parameters.ResponsiblePerson"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>使用单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.use"
            ></MyForm>
            <MyForm
              class="my_form"
              title="总体满意程度评价"
              :choice="true"
              :choice_list="['非常满意', '满意', '比较满意']"
              v-model="parameters.isuse"
            ></MyForm>

            <div class="form_title">
              <p>设计单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Design"
            ></MyForm>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.isDesign"
              ></MyForm>
              <MyForm
                class="my_form"
                title="建设单位主要负责人"
                :text="true"
                :small="true"
                v-model="parameters.ResponsiblePerson2"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>监理单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.supervisor"
            ></MyForm>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.issupervisor"
              ></MyForm>
              <MyForm
                class="my_form"
                title="监理单位总监工程师"
                :text="true"
                :small="true"
                v-model="parameters.Chiefengineer"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>推荐单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="推荐理由"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Reasons"
            ></MyForm>
            <MyForm
              class="my_form"
              title="申报资料情况"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Information"
            ></MyForm>
            <MyForm
              class="my_form2"
              title="申报工程获奖情况"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Engineering_Award"
            ></MyForm>
            <MyForm
              class="my_form"
              :left_height="100"
              title="优质工程推荐表（按类型选择表格下载填写后上传）"
              :isDowninpu="true"
              v-model="parameters.Recommendationform"
            ></MyForm>
          </div>
        </div> -->
      </div>
      <div class="form_right" v-if="$route.query.title == '贵州省建筑业优秀项目经理'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="essinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="申报单位" :background="essinfo ? '#EDF8F5' : '#FEF8EF'" :border="essinfo ? '#1ABF98' : '#FFB700'"
            :states="essinfo"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                推荐协会（单位）
              </div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.essinfo.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                申报人所在企业名称
              </div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.essinfo.msg2" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.essinfo.msg3" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">填报日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters2.essinfo.msg4"></el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="candidate">
          <Tips title="申报人信息" :background="condition ? '#EDF8F5' : '#FEF8EF'"
            :border="condition ? '#1ABF98' : '#FFB700'" :states="condition"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg1" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">性别</div>
                <div class="form_content">
                  <el-radio-group size="small" class="inpyabeb" v-model="parameters2.candidate.msg2">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">出生年月</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters2.candidate.msg3"></el-date-picker>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">民族</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg4" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">文化程度</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg5" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">政治面貌</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg6" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">参加工作时间</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg7" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">专业技术职称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg8" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  注册建造师等级及专业
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg9" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg10" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工作单位</div>
              <div class="form_long">
                <input placeholder="请输入" v-model="parameters2.candidate.msg11" type="text" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">单位地址</div>
              <div class="form_long">
                <input placeholder="请输入" v-model="parameters2.candidate.msg12" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">单位电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg13" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg14" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 110px">上传照片</div>
                <el-upload style="height: 110px" class="upload-demo" :action="$baseURL + '/api/home/upload/file/user'"
                  :limit="limit" accept=".jpg, .png" :on-success="handleSuccessUpload" :on-remove="handleRemove"
                  :file-list="parameters2.candidate.msg15" list-type="picture">
                  <el-button size="small" icon="el-icon-plus" style="margin-right: 10px">选择文件</el-button>
                  <div slot="tip" class="el-upload__tip" v-if="!parameters2.candidate.msg15">
                    只能上传jpg/png文件，且不超过500kb
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                近三年内负责的工程名称及所任项目经理职务：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.candidate.msg16"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                从事项目管理工作简历、业绩及奖惩情况：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.candidate.msg17"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Typicaldeeds">
          <Tips title="担任项目经理负责施工管理的典型事迹" :background="Selection ? '#EDF8F5' : '#FEF8EF'"
            :border="Selection ? '#1ABF98' : '#FFB700'" :states="Selection"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程项目名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程项目地点</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg2" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg3" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">合同工期</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg4" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">实际工期</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg5" placeholder="请输入" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工程概算</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg6" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">竣工决算</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg7" placeholder="请输入" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                实施项目管理的具体办法：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg8"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                获市（州）级及以上工程质量奖获绿色施工、新技术应用示范工程奖名称及时间
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg9"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                获文明施工现场时间及授予部门
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg10"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                安全生产情况
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg11"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="enclosure ? '#EDF8F5' : '#FEF8EF'" :border="enclosure ? '#1ABF98' : '#FFB700'"
            :states="enclosure"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                1、注册建造师证扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 1, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 1, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg1" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg1">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                2、安全生产考核合格证扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 2, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 2, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg2" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg2">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                3、获得市（州）级及以上工程质量奖或绿色施工、新技术应用示范工程奖证书扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 3, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 3, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg3" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg3">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                4、该获奖工程项目经理的任职文件扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 4, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 4, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg4" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg4">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                5、获得文明施工现场证明材料扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 5, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 5, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg5" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg5">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                6、企业法人承诺书(原件) 内容应包括: 1、申报资料真实有效有效。2、近三年所完成工程建设项目合格率达到100%， 没有发生过一般及以上工程建设质量安全事故，无拖欠农民工资的行为
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 6, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 6, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg6" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg6">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                7、贵州省优秀项目经理申报表
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="$baseURL + '/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 7, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 7, value)" :before-upload="beforeAvatarUpload"
                    :file-list="parameters2.enclosure.msg7" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg7">
                      只能上传png/jpg/pdf/doc文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '新技术示范工程'" id="exportPdf" ref="exportPdf">
        <div class="form_1">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" background="#FEF8EF" border="#FEF8EF" :states="true"></Tips>
        </div>
        <div class="form_1" v-for="item in count" :key="item">
          <Tips title="详细信息" background="#FEF8EF" border="#FFB700" :states="false"></Tips>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '省级施工工法'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="type_of_work">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="工程类别" :background="lefttitlelist[0].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[0].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[0].isok"></Tips>
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工程类别</div>
                <div class="form_long form_long-1">
                  <el-radio-group v-model="parameters4.info.type_of_work" size="small" class="inpyabeb"
                    @change="changeType(parameters4.info.type_of_work)">
                    <!-- <el-radio label="0">房屋建筑工程</el-radio>
			              <el-radio label="1">土木工程</el-radio>
			              <el-radio label="2">工业安装工程</el-radio> -->
                    <el-radio v-for="(item, index) in type_work_arr" :label="item">{{ item }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>
        <div class="form_1" id="type_of_major">
          <Tips title="专业分类" :background="lefttitlelist[1].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[1].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[1].isok"></Tips>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">专业分类</div>
                <div class="form_long form_long-1">
                  <el-radio-group v-model="parameters4.info.type_of_major" size="small" class="inpyabeb"
                    @change="changeMajorType(parameters4.info.type_of_major)">
                    <el-radio v-for="(item1, index1) in type_major_arr" :label="item1">{{ item1 }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-tabs>
          </el-form>
        </div>
        <div class="form_1" id="sj_info">
          <Tips title="基本信息" :background="lefttitlelist[2].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[2].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[2].isok"></Tips>
          <!-- <div class="border"></div>
          <div class="newlybuild" @click="addunit(2)">
            <img src="../assets/6622@2x.png" alt />
            <p>新增参建单位信息表</p>
          </div> -->
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工法名称</div>
                <div class="form_long">
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.name" />
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">编写单位</div>
                <div class="form_long">
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.unit" />
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="height: 62px">主要完成人姓名</div>
                <div class="form_long flex" style="padding-left: 21px;justify-content: space-between;padding-right: 21px;">
                  <div  v-for="(author,index) in parameters4.info.author_names" :key="author['starttime']">
                    <input style="width:120px"  @blur="add_author($event, author,index)" :placeholder="'输入姓名'+(index+1)" :value="author['name']" type="text" />
                  </div>
                </div>
              </div>


              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">申报联系人及电话</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters4.info.phone" />
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">邮箱</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters4.info.email" />
                    </div>
                  </div>
                </div>
              </div>
            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>

        <div class="form_1" id="sj_upload">
          <Tips title="申报材料上传" :background="lefttitlelist[4].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[4].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[4].isok"></Tips>
          <div class="form_dec">下列第1到第10项申报材料应为盖章后扫描件，为PDF格式，申报材料内容包括：</div>
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title">贵州省级工法申报汇总表（附件2）</div>
                <div class="form_upload form_long">
                  <div class="uploadcertificate">
                    <el-upload class="upload-demo" :on-remove="handleOnRemove1" :on-success="uploadSuccess1"
                      :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist1"
                      accept=".pdf">
                      <div class="form-upload-div">
                        <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                        <div slot="tip" class="el-upload__tip">
                          仅支持pdf格式，大小不超过100mb
                        </div>
                      </div>
                    </el-upload>
                  </div>
                  <div class="uploadcertificate">
                    <el-upload class="upload-demo" :on-remove="handleOnRemove2" :on-success="uploadSuccess2"
                      :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist2"
                      accept=".excel,.xls,.xlt,.xlsx">
                      <div class="form-upload-div">
                        <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传Excel
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          仅支持Excel格式，大小不超过100mb
                        </div>
                      </div>
                    </el-upload>
                  </div>
                  <div class="form_tip">
                    <el-tooltip content="除盖章后的PDF格式外另附EXCEL格式电子文档" style="color: indianred;" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title" style="background: #f5f8fb;">贵州省级工法申报表（附件1）</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove3" :on-success="uploadSuccess3"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist3"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法文本</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove4" :on-success="uploadSuccess4"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist4"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip">
                    <el-tooltip content="工法编写内容应当包括:前言、工法特点、适用范围、工艺原理、施工工艺流程及操作要点、材料与设备、质量控制、安全措施、环保措施、效益分析和应用实例；"
                      style="color: indianred;" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">企业级工法公布文件</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove5" :on-success="uploadSuccess5"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist5"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法关键技术鉴定的有关资料</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove6" :on-success="uploadSuccess6"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist6"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">工程应用证明</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove7" :on-success="uploadSuccess7"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist7"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip" style="width: 600px;margin-top: 17px;">
                    <el-tooltip
                      content="包括应用工程的监理单位或建设单位提供的证明(原件),施工许可证或开工报告复印件,施工合同复印件(只提供封面,含发包单位、承包单位及承包范围内容页及盖章页),提供的工程实例不少于两项,工程至少有一项在贵州省范围内;"
                      style="color: indianred;" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">经济效益证明</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove8" :on-success="uploadSuccess8"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist8"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">科技查新报告</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove9" :on-success="uploadSuccess9"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist9"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip" style="width: 600px;margin-top: 17px;">
                    <el-tooltip content="科技查新报告由技术情报部门提供;" style="color: indianred;" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">涉及他方专利的无争议声明书</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove10" :on-success="uploadSuccess10"
                    :action="$baseURL + '/api/home/upload/file/user'" :file-list="parameters4.info.filelist10"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">关键技术标准、专利证书、科技成果获奖证明等其他有关材料</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :action="$baseURL + '/api/home/upload/file/user'"
                    :file-list="parameters4.info.filelist11" :on-remove="handleOnRemove11" :on-success="uploadSuccess11"
                    accept=".pdf">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法应用的有关照片</div>
                <div class="uploadcertificate form_long" style="padding-bottom: 10px;">
                  <el-upload style="display: grid;
					       padding-top: 20px;
					       padding-bottom: 180px;
					       overflow: scroll;
					       flex-wrap: wrap;" class="upload-demo" :action="$baseURL + '/api/home/upload/file/user'"
                    :on-remove="handleOnRemove12" :on-success="uploadSuccess12" :file-list="parameters4.info.filelist12"
                    accept=".jpg, .png,.mp4,.avi,.flv" >
                    <div class="form-upload-div" style="margin-bottom: 30px">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 选择文件</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持jpg,png,.mp4,.avi,.flv格式，大小不超过300mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>


            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '贵州省优秀施工企业'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="essinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" :background="essinfo ? '#EDF8F5' : '#FEF8EF'" :border="essinfo ? '#1ABF98' : '#FFB700'"
            :states="essinfo"></Tips>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">企业名称</div>
                <div class="form_long form_long-1">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg1" />
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工商注册地址</div>
                <div class="form_long">
                  <input type="text"  placeholder="请输入" v-model="parameters1.essinfo.msg2" />
                </div>
              </div>
              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">法定代表人</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg3" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">电话</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">申报企业类别</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.essinfo.msg5">
                    <el-radio label="1">施工总承包企业</el-radio>
                    <el-radio label="2">专业承包企业</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">申报时间</div>
                  <div class="form_content">
                    <div class="input">
                      <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters1.essinfo.msg6"></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 188px; text-align: center">
                  企业申报意见
                </div>
                <div class="form_textarea">
                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.essinfo.msg7"></textarea>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 188px; text-align: center">
                  推荐意见（各市、州建筑业协会或企业主管部门）
                </div>
                <div class="form_textarea">
                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.essinfo.msg8"></textarea>
                </div>
              </div>
            </el-tabs>
          </el-form>
        </div>
        <div class="form_1" id="condition">
          <Tips title="基本条件" :background="condition ? '#EDF8F5' : '#FEF8EF'" :border="condition ? '#1ABF98' : '#FFB700'"
            :states="condition"></Tips>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">主项资质及等级</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.condition.msg1" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">取得时间</div>
                  <div class="form_content">
                    <div class="input">
                      <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters1.condition.msg2"></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">本年度和上一年度发生一般及以上工程质量安全事故及有关投诉</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg3">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在拖欠农民工工资行为</div>
                  <div class="form_content">
                    <div class="input">
                      <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg4">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在失信、违法违规事件</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg5">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在恶意拖欠建筑业税收行为</div>
                  <div class="form_content">
                    <div class="input">
                      <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg6">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">通过ISO9000系列三项管理体系认证</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg7">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">

                </div>
              </div>


            </el-tabs>
          </el-form>

        </div>
        <div class="form_1" id="Selection">
          <Tips title="评选指标" :background="Selection ? '#EDF8F5' : '#FEF8EF'" :border="Selection ? '#1ABF98' : '#FFB700'"
            :states="Selection"></Tips>


            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">上一年度建筑业总产值</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg1">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">上一年度省外（境外）完成的产值</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg2">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">上一年度现金净流</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg3">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">上一年度净利润总额</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg4">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">近三年获得企业管理类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg5">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">近三年获得省级及以上工程质量安全类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg6">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">近三年获得新技术、绿色施工类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg7">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">近三年获得技术、专利类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg8">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

            </el-tabs>
          </el-form>



        </div>
        <div class="form_1" id="Material">
          <Tips title="企业业绩材料" :background="parameters1.Material != '' && parameters1.Material != undefined ? '#EDF8F5'
              : '#FEF8EF'
          " :border="parameters1.Material != '' && parameters1.Material != undefined ? '#1ABF98' : '#FFB700'
" :states="
  parameters1.Material != '' && parameters1.Material != undefined
"></Tips>

                <div class="form_box_content">
              <div class="my_form">
                <div class="form_title" style="height: 188px; text-align: center">
                  企业业绩材料（文字部分）
                </div>
                <div class="form_textarea">


                  <div>
                    <el-popover
                    placement="top-start"
                    title=""
                    width="660"
                    trigger="hover"
                    content="内容应包括企业的基本情况、党的建设、精神文明建设、职工生活水平、企业建立现代企业制度、获奖情况、工程质量和安全生产情况、重视新技术开发和应用情况、无拖欠农民工工资情况等几个方面的业绩。">
                    <div  slot="reference" >
                      <i class="el-icon-caret-bottom" style="color:#FF989F;"></i>
                    </div>
                  </el-popover>
                  </div>

                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.Material"></textarea>
                </div>
              </div>
            </div>


        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="enclosure ? '#EDF8F5' : '#FEF8EF'" :border="enclosure ? '#1ABF98' : '#FFB700'"
            :states="enclosure"></Tips>


            <div class="form_box_content">
              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业营业执照扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 1, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 1, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg1" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg1">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业资质证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 2, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 2, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg2" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg2">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 3, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 3, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg3" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg3">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 4, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 4, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg4" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg4">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 5, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 5, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg5" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg5">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业法人承诺书（原件） 内容应包括：1、申报资料真实有效。2、本年度和上一年度没有发生一般及以上工程质量安全事故及有关投诉，无拖欠农民工工资、建筑业税收行为、无失信、违法违规事件(复印件)
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 6, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 6, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg6" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg6">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得企业管理类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 7, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 7, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg7" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg7">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得省级及以上工程质量安全类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 8, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 8, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg8" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg8">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得新技术、绿色施工类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 9, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 9, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg9" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg9">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得技术、专利类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 10, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 10, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg10" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg10">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  上一年度企业财务审计报表扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 11, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 11, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg11" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg11">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  贵州省优秀施工企业申报表
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="$baseURL + '/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 12, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 12, value)" :before-upload="beforeAvatarUpload"
                      :file-list="parameters1.enclosure.msg12" :limit="1" accept=".jpg, .png, .pdf, .doc, .docx">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg12">
                        只能上传png/jpg/pdf/doc文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

          </div>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '贵州省绿色施工示范工程'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="info">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" :background="lefttitlelist[0].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[0].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[0].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设规模和分类</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg2" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">计划开工日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters3.info.msg3"></el-date-picker>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">计划竣工日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters3.info.msg4"></el-date-picker>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">主要结构</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg5" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工程所在地</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg6" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">承建单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg7" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg8" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">设计单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg9" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">项目所在地</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg10" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>示范工程项目负责人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg11" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg12" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg13" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>示范工程项目技术负责人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg14" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg15" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg16" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>示范工程所在承建单位联系人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg17" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg18" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg19" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电子邮箱</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg20" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="ProjectOverview">
          <Tips title="工程概况" :background="lefttitlelist[1].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[1].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[1].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程概况
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.ProjectOverview.msg1"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Indicators">
          <Tips title="拟完成绿色施工主要指标情况" :background="lefttitlelist[2].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[2].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[2].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                环境保护
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg1"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                节材与材料资源利用
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg2"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                节水与水资源利用
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg3"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                节能与能源利用
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg4"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                节地与土地资源保护
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg5"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                拟组织绿色施工技术攻关和创新的项目及内容（限1000字）
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg6"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程进度计划
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg7"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                预期经济效益与社会效益
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg8"></textarea>
              </div>
            </div>
            <!-- <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                绿色施工示范工程承建单位意见
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters1.environmental_protection"
                ></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                市、州行业协会（或企业主管部门）意见
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters1.environmental_protection"
                ></textarea>
              </div>
            </div> -->
          </div>
        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="lefttitlelist[3].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[3].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[3].isok"></Tips>
          <GreenProjcet @greenPorject="greenPorject" title1="绿色施工专项方案" title2="贵州省绿色施工示范工程申报表"
            :parameters3="parameters3.Upload" />
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '2021年半年报' || $route.query.title == '2021年度年报'" id="exportPdf"
        ref="exportPdf">
        <div class="form_1">
          <Tips title="填表须知" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="form_box_content" style="text-align: start; font-size: 14px; color: #0c0d0f">
            <p>
              1、本企业郑重承诺所填数据皆为真实数据，无不实、捏造、造假情况，对上传所有内容负责；<br />
              2、注册类人员包括一、二级注册建造师、注册造价师、注册监理工程师、注册安全工程师、注册会计师。（若一人有多种执业资格，只计算一次）<br />
              3、中、高级技工指企业内从事相关工种，包括瓦工、钢筋工、混凝土工、抹灰工、防水工、管道工、水暖工、测量放线工、木工、电焊工、油漆工、安装起重工、电气设备安装调试工、工程机械维修工、中小型机械操作工等，经市级以上建筑职业技能岗位主管部门培训考核，取得中级技工及以上级别的人员。<br />
              4、所有内容只限于调研分析所用，将会严格保密。在填写过程中有任何疑问请致电：0851-85360455；<br />
            </p>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业概况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="my_form" style="margin-top: 20px">
            <div class="form_title" style="height: 62px">企业全称</div>
            <div class="form_long">
              <input placeholder="请输入" type="text" />
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">注册地址</div>
            <div class="form_long">
              <input placeholder="请输入" type="text" />
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">填表人</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">联系电话</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">企业性质</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                企业资质类型及等级
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业生产经营情况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">完成总产值</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">应收账款</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">现金流</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">实现利润</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">总资产</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">资产负债率</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form_title">
            <p style="text-align: start; margin: 20px 0">业务结构</p>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">建筑施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">住宅类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">公共类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">工业类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式混凝土项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式钢结构项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">市政施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">城市道路项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">轨道交通项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">地下管廊（线）项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">绿化景观项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">污水（垃圾）处理项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form2 my_formmin">
              <div class="form_title">房地产开发</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">铁路施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">公路施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">电力施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">煤炭施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">冶金施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">石油化工施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">建材装饰施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">水利施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">海外项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">PPP项目数量及投资额</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业生产经营情况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得国家级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得国家级奖项名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得省、市级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得省、市级奖项名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得专利数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              发明专利名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 188px; text-align: center">
              实用新型名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">高新技术及科技研发投入</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">技术中心级别和数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span></span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>个</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">行政管理人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">接收应届毕业生数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">专职科技研发人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">院士数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">技能大师数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">博士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">硕士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">注册类人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级职称人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级技工数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="上传附件" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="my_form2">
            <div class="form_title" style="height: 100px">上传附件</div>
            <div class="uploadcertificate">
              <el-upload class="upload-demo" :action="$baseURL + '/api/home/upload/file/user'" :file-list="[filelist]"
                accept=".jpg, .png">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  仅支持pdf格式，大小不超过100mb
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { SaveDraft, Draftrecord, Declare, DeclareDetails, Declare_modify } from "../utils/api";
import Footer from "../components/Footer";
import MyForm from "../components/Modal/my_form";
import Tips from "../components/Modal/tips"; //提示组件
import GreenProjcet from '../components/fromProjcet/greenProject.vue'
export default {
  components: {
    Tips,
    MyForm,
    Footer,
    GreenProjcet
  },
  data() {
    return {
      btnSaveStatus: false,
      currentSubmit: false,
      enclosure: false,//贵州省优秀施工企业 上传附件是否传完
      candidatefileimg: [],//贵州省优秀施工企业 照片
      essinfo: false,//贵州省优秀施工企业 基本信息是否填完
      condition: false,//贵州省优秀施工企业 基本条件是否填完
      Selection: false,//贵州省优秀施工企业 评选指标是否填完
      tipserror: 0,
      form: {
        type: [],
      },
      islist: "0",
      ruleForm: {
        name: "",
        contact_number: "",
        unified_social_credit_code: "",
        enterprise_nature: "",
        is_list: 0,
        token: "",
        established_time: "",
        registered_capital: "",
        legal_representative: "",
        legal_representative_id: "", //法定身份证号
        // Social_name:'',//社会组织名称
        other_phone: "", //法人电话
        job: "", //本组织现任职务
        is_secretary_general: "", //是否秘书长
        is_representative: "", //是否法定代表人
        political_outlook: "", //政治面貌
        education_degree: "", //文化程度
        is_social_worker: "", //是否社工师
        is_employees: "", //是否本组织从业人员
        professional_qualification_level: "", //职业资格水平
        business_license: "",
        is_show: "",
        party_posts: "", //本组织党内职务
        company: "", //党组织关系所在单位
        introduce: "", //基本介绍
        head_portrait: "", //企业标识图
        certifications: "",//上传资质证书
        address: "", //企业地址
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        introduce: [
          {
            required: true,
            message: "请输入单位的基本介绍文字...",
            trigger: "change",
          },
        ],
        party_posts: [
          {
            required: true,
            message: "请选择本组织党内职务",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入党组织关系所在单位",
            trigger: "change",
          },
        ],
        professional_qualification_level: [
          {
            required: true,
            message: "请选择职业资格水平",
            trigger: "change",
          },
        ],
        is_employees: [
          {
            required: true,
            message: "是否本组织从业人员",
            trigger: "change",
          },
        ],
        is_social_worker: [
          {
            required: true,
            message: "是否社工师",
            trigger: "change",
          },
        ],
        political_outlook: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: "change",
          },
        ],
        education_degree: [
          {
            required: true,
            message: "请选择文化程度",
            trigger: "change",
          },
        ],
        contact_number: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
        ],
        unified_social_credit_code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        enterprise_nature: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: "change",
          },
        ],
        is_list: [
          {
            required: true,
            message: "请选择是否上市",
            trigger: "change",
          },
        ],
        established_time: [
          {
            type: "string",
            required: true,
            message: "请选择成立日期",
            trigger: "change",
          },
        ],
        registered_capital: [
          {
            required: true,
            message: "请输入注册资本/万",
            trigger: "change",
          },
        ],
        legal_representative: [
          {
            // type: 'array',
            required: true,
            message: "请输入发定代表人",
            trigger: "change",
          },
        ],
        legal_representative_id: [
          {
            required: true,
            message: "请输入法人身份证",
            trigger: "change",
          },
        ],
        // Social_name:[{
        // 	required: true,
        // 	message: '请输入社会组织名称',
        // 	trigger: 'change'
        // }],
        other_phone: [
          {
            required: true,
            message: "请输入法定代表人或指定代表手机号码",
            trigger: "change",
          },
        ],
        job: [
          {
            required: true,
            message: "请选择本组织现任职务（按最高职务）",
            trigger: "change",
          },
        ],
        is_secretary_general: [
          {
            required: true,
            message: "是否任本组织秘书长",
            trigger: "change",
          },
        ],
        is_representative: [
          {
            required: true,
            message: "是否任本组织法定代表人",
            trigger: "change",
          },
        ],
        business_license: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "change",
          },
        ],
        is_show: [
          {
            required: true,
            message: "请选择是否展示",
            trigger: "change",
          },
        ],
      },
      rId: 0,//记录id
      SupplementaryContent: {},
      dialogVisible: false,
      dialogImageUrl: "",
      Businesslicense: [],
      filechangelist2: {},
      filechangelist: {},
      Contractorinfo: {},
      ProjectOverview: {},
      DeclarationSummary: {},
      Recommendationform: false,
      Informationparticipatingunits: {},
      lefttitlelist: [],
      fileList: [],
      Tipstates: false,
      Tipsbackground: "#FEF8EF",
      Tipsborder: "#FFB700",
      is_list: "",
      count: 1,
      oldcount: 1,
      states: 6,
      limit: 1,
      issumbit: true,
      parameters: {},
      parameters1: {
        essinfo: {},
        Material: {},
        condition: {},
        Selection: {},
        enclosure: {}
      },
      parameters2: {
        essinfo: {},
        candidate: {},
        Typicaldeeds: {},
        enclosure: {}
      },
      parameters3: {
        info: {},
        Indicators: {},
        ProjectOverview: {},
        Upload: {
          GreenConstruction: [],
          GreenDeclarationForm: []
        }
      },
      parameters4: {
        info: {
          type_of_work: 0,
          type_of_major: 0,
          name: "",
          unit: "",
          phone: "",
          email: "",
          author_names: [
            {
              name: "",
              starttime: "",
            },
          ],
          filelist1: [],
          filelist2: [],
          filelist3: [],
          filelist4: [],
          filelist5: [],
          filelist6: [],
          filelist7: [],
          filelist8: [],
          filelist9: [],
          filelist10: [],
          filelist11: [],
          filelist12: [],
        }
      },
      type_work_arr: [
        "房屋建筑工程",
        "土木工程",
        "工业安装工程",
      ],
      type_major_arr: [
        "地基与基础",
        "主体结构",
        "钢结构",
        "装饰与屋面",
        "水电与智能",
        "其它",
      ],
      type_major_arr1: [
        "地基与基础",
        "主体结构",
        "钢结构",
        "装饰与屋面",
        "水电与智能",
        "其它",
      ],
      type_major_arr2: [
        "公路",
        "铁路",
        "隧道",
        "桥梁",
        "堤坝与电站",
        "矿山",
        "其他",

      ],
      type_major_arr3: [
        "工业设备",
        "工业管道",
        "电气装置与自动化",
        "其它",
      ],
      activeName: '',
    };
  },
  async created() {
    var _this = this;
    let res;
    switch (_this.$route.query.title) {

      case "省优工程“黄果树杯”":
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
          }
        }
        if (!res) {
          res = await Draftrecord(this.$route.query.id);
        }
        this.lefttitlelist = [
          {
            name: "承建单位（申报单位）简况",
            isok: false,
            id: "#Contractorinfo",
          },
          { name: "参建单位信息", isok: false, id: "#index0" },
          { name: "申报工程概况", isok: false, id: "#ProjectOverview" },
          { name: "申报理由", isok: false, id: "#Explain_the_reason" },
          { name: "有关单位意见", isok: true, id: "#Explain_the_opinion" },
          {
            name: "申报登记表需补充内容",
            isok: false,
            id: "#SupplementaryContent",
          },
          {
            name: "申报汇总表需补充内容",
            isok: false,
            id: "#DeclarationSummary",
          },
          // { name: "推荐表", isok: false, id: "#Recommendationform" },
        ];
        if (JSON.stringify(res) == "{}") {
          this.parameters = {
            Explain_the_reason: "",
            Recommendationform: [],
            DeclarationSummary: {},
            Contractorinfo: {},
            ProjectOverview: {},
            SupplementaryContent: {
              certificate: [{ uploadinput: "", uploadlist: [] }],
              Contactemail: "",
              Unitcontact: "",
              contactnumber: "",
              Architecture_msg2_file: [],
              Architecture_msg3_file: [],
              is1arr: [],
              is2arr: [],
              is3arr: [],
              is4arr: [],
              is5arr: [],
              is6arr: [],
              is7arr: [],
              is8arr: [],
              is9arr: [],
              is10arr: [],
              is11arr: [],
              is12arr: [],
              is13arr: [],
              is14arr: [],
              is15arr: [],
              is16arr: [],
              is17arr: [],
              is18arr: [],
              is19arr: [],
              is20arr: [],
              is21arr: [],
              is22arr: [],
              is1: "0",
              is2: "0",
              is3: "0",
              is4: "0",
              is5: "0",
              is6: "0",
              is7: "0",
              is8: "0",
              is9: "0",
              is10: "0",
              is11: "0",
              is12: "0",
              is13: "0",
              is14: "0",
              is15: "0",
              is16: "0",
              is17: "0",
              is18: "0",
              is19: "0",
              is20: "0",
              is21: "0",
              is22: "0"
            },
            Architecture_msg3_file: [],
            Architecture_msg2_file: [],
            Approval_comments: "",
            Architecture_msg1: "",
            Architecture_msg2: "",
            Architecture_msg3: "",
            Awarding_unit: "",
            unitinfo: [
              {
                Construction_content: "",
                Construction_proportion: "",
                Construction_workload: "",
                Qualification_level: "",
                Telephone: "",
                brief_introduction: "",
                codeyouzheng: "",
                guding_phone: "",
                leave: "",
                movephone1: "",
                name2: "",
                name3: "",
                name4: "",
                phone2: "",
                phone3: "",
                phoneaddress: "",
                postion: "",
                unitname: "",
                work_department: "",
              },
            ],
          };
        } else {
          for (const key in res.content) {
            if (res.content[key] == null) {
              res.content[key] = "";
            }
            this.parameters = res.content;
          }
          if (res.content.unitinfo.length == 0) {
            this.lefttitlelist.splice(1, 1);
          }
          for (let i = 1; i < res.content.unitinfo.length; i++) {
            this.lefttitlelist.splice(i + 1, 0, {
              name: "参建单位信息" + (i == 0 ? "" : i),
              isok: false,
              id: "#index" + i,
            });
          }
          this.parameters = res.content;
          this.Recommendationform = true

          this.parameters.SupplementaryContent.is17 = '0';
          this.parameters.SupplementaryContent.is19 = '0';
          //this.lefttitlelist[this.parameters.unitinfo.length + 6].isok = true;
        }

        break;
      case "新技术示范工程":
        res = await Draftrecord(this.$route.query.id, this.parameters3);
        if (JSON.stringify(res) == "{}") {
          this.parameters3 = {};
          return false;
        }
        this.parameters3 = res.content;
        break;
      case "贵州省优秀施工企业":
        this.lefttitlelist = [
          { name: "基本信息", isok: false, id: "#essinfo" },
          { name: "基本条件", isok: false, id: "#condition" },
          { name: "评选指标", isok: false, id: "#Selection" },
          { name: "企业业绩材料", isok: false, id: "#Material" },
          { name: "上传附件", isok: false, id: "#Upload" }
        ];
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
          }
        } else {
          res = await Draftrecord(this.$route.query.id);
        }
        if (JSON.stringify(res) == "{}") {
          this.parameters1 = {
            essinfo: {},
            condition: {},
            Selection: {},
            enclosure: {}
          };
        } else {
          this.parameters1 = res.content;
          for (const key in this.parameters1) {
            if (Array.isArray(this.parameters1[key])) {
              this.parameters1[key] = {}
            }
          }
          console.log(66, this.parameters1);
        }
        break;

      case "贵州省绿色施工示范工程":
        this.lefttitlelist = [
          { name: "基本信息", isok: false, id: "#info" },
          { name: "工程概况", isok: false, id: "#ProjectOverview" },
          { name: "拟完成绿色施工主要指标情况", isok: false, id: "#Indicators" },
          { name: "上传附件", isok: false, id: "#Upload" }
        ];
        res = await Draftrecord(this.$route.query.id);
        if (JSON.stringify(res) == "{}") {
          this.parameters3 = {
            info: {},
            Indicators: {},
            Upload: {
              GreenConstruction: [],
              GreenDeclarationForm: []
            },
            ProjectOverview: {}
          };
        } else {
          this.parameters3 = res.content;
          for (const key in this.parameters3) {
            if (Array.isArray(this.parameters3[key])) {
              this.parameters3[key] = {}
            }
          }
          console.log(66, this.parameters3);
        }
        break;

      case "省级施工工法":
        this.lefttitlelist = [
          { name: "工程类别", isok: false, id: "#type_of_work" },
          { name: "专业分类", isok: false, id: "#type_of_major" },
          { name: "基本信息", isok: false, id: "#sj_info" },
          { name: "主要完成人", isok: false, id: "#sj_info" },
          { name: "申报材料上传", isok: false, id: "#sj_upload" }
        ];
        res = await Draftrecord(this.$route.query.id);

        console.log('----------------------res----------------------');
        console.log(res);
        if (JSON.stringify(res) == "{}") {
          this.parameters4 = {
            Indicators: {},
            ProjectOverview: {},
            Upload: {},
            info: {
              author_names: [
                {
                  name: "",
                  starttime: "",
                },
              ],
            }
          };
          this.upAuthor()
        } else {
          if (!res.content.Indicators) {

          }
          if (!res.content.info) {

          }
          this.parameters4 = res.content;
          for (const key in this.parameters4) {
            if (Array.isArray(this.parameters4[key])) {
              this.parameters4[key] = {}
            }
          }
          console.log("this.parameters4.info.type_of_work");
          console.log(this.parameters4.info.type_of_work);
          if (this.parameters4.info.type_of_work == null) {
            this.parameters4.info.type_of_work = '房屋建筑工程';
          }
          this.changeType(this.parameters4.info.type_of_work);
          var major = this.parameters4.info.type_of_major;
          this.parameters4.info.type_of_major = major;

          // info.author_names
          this.upAuthor()
        }
        break;
    }
  },
  computed: {
    issumbitshow: function () {
      let issumbit = true;
      for (let i = 0; i < this.lefttitlelist.length; i++) {
        if (!this.lefttitlelist[i].isok) {
          issumbit = false;
        }
      }
      return issumbit;
    },
  },
  watch: {
    "parameters.Contractorinfo": {
      handler: function (newV, oldV) {
        if (Array.isArray(this.parameters.Contractorinfo)) {
          this.parameters.Contractorinfo = {};
        }
        let count = 0;
        this.Contractorinfo.Tipsbackground = "#FEF8EF";
        this.Contractorinfo.Tipstates = false;
        this.Contractorinfo.Tipsborder = "#FFB700";
        this.lefttitlelist[0].isok = false;
        for (const key in this.parameters.Contractorinfo) {
          if (!this.parameters.Contractorinfo[key]) return;
          count++;
          if (count >= 21) {
            this.Contractorinfo.Tipsbackground = "#EDF8F5";
            this.Contractorinfo.Tipstates = true;
            this.Contractorinfo.Tipsborder = "#1ABF98";
            this.lefttitlelist[0].isok = true;
          }
        }
      },
      deep: true,
    },
    "parameters.unitinfo": {
      handler: function (newV, oldV) {
        let count = 0;
        let num = 19;
        let isnull = true;
        for (let i = 0; i < this.parameters.unitinfo.length; i++) {
          for (const key in this.parameters.unitinfo[i]) {
            if (
              this.parameters.unitinfo[i][key] == "" ||
              this.parameters.unitinfo[i][key] == null
            ) {
              isnull = false;
            }
          }
          if (isnull == true) {
            this.Informationparticipatingunits.Tipsbackground = "#EDF8F5";
            this.Informationparticipatingunits.Tipstates = true;
            this.Informationparticipatingunits.Tipsborder = "#1ABF98";
            this.lefttitlelist[i + 1].isok = true;
          } else {
            this.Informationparticipatingunits.Tipsbackground = "#FEF8EF";
            this.Informationparticipatingunits.Tipstates = false;
            this.Informationparticipatingunits.Tipsborder = "#FFB700";
            this.lefttitlelist[i + 1].isok = false;
          }
        }
      },
      deep: true,
    },
    "parameters.ProjectOverview": {
      handler: function (newV, oldV) {
        if (Array.isArray(this.parameters.ProjectOverview)) {
          this.parameters.ProjectOverview = {};
        }
        let count = 0;
        this.ProjectOverview.Tipsbackground = "#FEF8EF";
        this.ProjectOverview.Tipstates = false;
        this.ProjectOverview.Tipsborder = "#FFB700";
        this.lefttitlelist[this.parameters.unitinfo.length + 1].isok = false;
        for (const key in this.parameters.ProjectOverview) {
          if (!this.parameters.ProjectOverview[key]) return;
          count++;
          if (count >= 16) {
            this.ProjectOverview.Tipsbackground = "#EDF8F5";
            this.ProjectOverview.Tipstates = true;
            this.ProjectOverview.Tipsborder = "#1ABF98";
            this.lefttitlelist[this.parameters.unitinfo.length + 1].isok = true;
          }
        }
      },
      deep: true,
    },
    "parameters.Explain_the_reason": {
      handler() {
        if (this.parameters.Explain_the_reason != "") {
          this.lefttitlelist[this.parameters.unitinfo.length + 2].isok = true;
        } else {
          this.lefttitlelist[this.parameters.unitinfo.length + 2].isok = false;
        }
      },
      deep: true,
    },
    parameters: {
      handler: function (newval, oldval) {
        console.log(newval);
        let count = 0;
        let isshenbao = 0;
        let istrue = true;
        for (const key in this.parameters.SupplementaryContent) {
          if (this.parameters.SupplementaryContent[key] === "" || this.parameters.SupplementaryContent[key] === null || this.parameters.SupplementaryContent[key] === undefined) {
            // console.log(key,JSON.stringify(this.parameters.SupplementaryContent[key]));
            istrue = false;
          }
          for (let i = 1; i <= 22; i++) {
            if (this.parameters.SupplementaryContent["is" + i] == "1") {
              if (
                this.parameters.SupplementaryContent["is" + i + "arr"].length <
                1
              ) {
                console.log(i, '图像i');
                istrue = false;
              }
            }
          }
        }

        if (istrue) {
          this.SupplementaryContent.Tipsbackground = "#EDF8F5";
          this.SupplementaryContent.Tipstates = true;
          this.SupplementaryContent.Tipsborder = "#1ABF98";
          this.lefttitlelist[this.parameters.unitinfo.length + 4].isok = true;
          console.log(11);
        } else {
          this.SupplementaryContent.Tipstates = false;
          this.SupplementaryContent.Tipsbackground = "#FEF8EF";
          this.SupplementaryContent.Tipsborder = "#FFB700";
          this.lefttitlelist[this.parameters.unitinfo.length + 4].isok = false;
          console.log(22);
        }

        console.log(996, this.Recommendationform);
      },
      deep: true,
    },
    "parameters.DeclarationSummary": {
      handler() {
        let count = 0;
        if (Array.isArray(this.parameters.DeclarationSummary)) {
          this.parameters.DeclarationSummary = {};
        }
        this.DeclarationSummary.Tipsbackground = "#FEF8EF";
        this.DeclarationSummary.Tipstates = false;
        this.DeclarationSummary.Tipsborder = "#FFB700";
        this.lefttitlelist[this.parameters.unitinfo.length + 5].isok = false;
        for (const key in this.parameters.DeclarationSummary) {
          if (!this.parameters.DeclarationSummary[key]) return;
          count++;
          if (count >= 7) {
            this.DeclarationSummary.Tipsbackground = "#EDF8F5";
            this.DeclarationSummary.Tipstates = true;
            this.DeclarationSummary.Tipsborder = "#1ABF98";
            this.lefttitlelist[this.parameters.unitinfo.length + 5].isok = true;
          }
        }
      },
      deep: true,
    },
    parameters1: {
      handler() {
        let copykey;
        console.log('OKOKOK');
        for (const key in this.parameters1.enclosure) {
          if (typeof this.parameters1.enclosure[key] == 'boolean') {
            if (this.parameters1.enclosure[key] == false) {
              copykey = key.slice(3, 5)
              delete this.parameters1.enclosure['msg' + (parseInt(copykey) + 1)]
            }
          }
        }
        this.essinfo = this.noempty(this.parameters1.essinfo, 6, "msg");
        this.condition = this.noempty(this.parameters1.condition, 7, "msg");
        this.Selection = this.noempty(this.parameters1.Selection, 8, "msg");
        if (this.parameters1.enclosure.msg12) {
          this.enclosure = this.parameters1.enclosure.msg12.length >= 1
        }
        console.log('this.enclosure',this.enclosure)
        this.parameters1.enclosure.msg12 == undefined ? this.enclosure = false : this.enclosure = true
        this.lefttitlelist[0].isok = this.essinfo;
        this.lefttitlelist[1].isok = this.condition;
        this.lefttitlelist[2].isok = this.Selection;
        this.lefttitlelist[3].isok =
          this.parameters1.Material != "" &&
          this.parameters1.Material != undefined;
        this.lefttitlelist[4].isok = this.enclosure;
        console.log(this.parameters1.enclosure.msg2);
      },
      deep: true
    },
    parameters2: {
      handler() {
        let copykey;
        for (const key in this.parameters2.enclosure) {
          if (typeof this.parameters2.enclosure[key] == 'boolean') {
            if (this.parameters2.enclosure[key] == false) {
              copykey = key.slice(3, 5)
              delete this.parameters2.enclosure['msg' + (parseInt(copykey) + 1)]
            }
          }
        }
        this.essinfo = this.noempty(this.parameters2.essinfo, 4, "msg");
        this.condition = this.noempty(this.parameters2.candidate, 17, "msg");
        this.Selection = this.noempty(this.parameters2.Typicaldeeds, 11, "msg");
        console.log('enclosure', this.parameters2.enclosure);
        if (this.parameters2.enclosure.msg7) {
          this.enclosure = this.parameters2.enclosure.msg7.length >= 1
        }
        this.parameters2.enclosure.msg7 == undefined ? this.enclosure = false : this.enclosure = true
        this.lefttitlelist[0].isok = this.essinfo;
        this.lefttitlelist[1].isok = this.condition;
        this.lefttitlelist[2].isok = this.Selection;
        this.lefttitlelist[3].isok = this.enclosure;
      },
      deep: true
    },
    parameters3: {
      handler() {
        this.lefttitlelist[0].isok = this.noempty(this.parameters3.info, 20, "msg");
        this.lefttitlelist[1].isok = this.noempty(this.parameters3.ProjectOverview, 1, "msg");
        this.lefttitlelist[2].isok = this.noempty(this.parameters3.Indicators, 8, "msg");
      },
      deep: true
    },
    "parameters4": {
      handler: function (newV, oldV) {
        this.lefttitlelist[0].isok = false;
        if (this.parameters4.info.type_of_work) {
          this.lefttitlelist[0].isok = true;
        }
        this.lefttitlelist[1].isok = false;
        if (this.parameters4.info.type_of_major) {
          this.lefttitlelist[1].isok = true;
        }
        this.lefttitlelist[2].isok = false;
        if (this.parameters4.info.name &&
          this.parameters4.info.unit &&
          this.parameters4.info.phone &&
          this.parameters4.info.email) {
          this.lefttitlelist[2].isok = true;
        }
        this.lefttitlelist[3].isok = false;
        if (this.parameters4.info.author_names && this.parameters4.info.author_names.length > 0) {
          this.lefttitlelist[3].isok = true;
        }
        this.lefttitlelist[4].isok = false;

        if (this.parameters4.info.filelist1 != null &&
          this.parameters4.info.filelist2 != null &&
          this.parameters4.info.filelist3 != null &&
          this.parameters4.info.filelist4 != null &&
          this.parameters4.info.filelist5 != null &&
          this.parameters4.info.filelist6 != null &&
          this.parameters4.info.filelist7 != null &&
          this.parameters4.info.filelist8 != null &&
          this.parameters4.info.filelist9 != null &&
          this.parameters4.info.filelist10 != null &&
          this.parameters4.info.filelist11 != null &&
          this.parameters4.info.filelist12 != null
        ) {
          this.lefttitlelist[4].isok = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    lefttitlelist4_check() {
      this.lefttitlelist[4].isok = false;
      if (this.parameters4.info.filelist1 != null &&
        this.parameters4.info.filelist2 != null &&
        this.parameters4.info.filelist3 != null &&
        this.parameters4.info.filelist4 != null &&
        this.parameters4.info.filelist5 != null &&
        this.parameters4.info.filelist6 != null &&
        this.parameters4.info.filelist7 != null &&
        this.parameters4.info.filelist8 != null &&
        this.parameters4.info.filelist9 != null &&
        this.parameters4.info.filelist10 != null &&
        this.parameters4.info.filelist11 != null &&
        this.parameters4.info.filelist12 != null
      ) {
        this.lefttitlelist[4].isok = true;
      }
    },
    uploadSuccess1(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist1 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess2(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist2 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess3(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist3 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess4(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist4 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess5(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist5 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess6(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist6 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess7(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist7 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess8(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist8 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess9(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist9 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess10(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist10 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess11(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist11 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess12(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      console.log(this.parameters4.info.filelist12);
      if (typeof (this.parameters4.info.filelist12) == "undefined") {
        this.parameters4.info.filelist12 = [data];
      } else {
        this.parameters4.info.filelist12.push(data);
      }
      this.lefttitlelist4_check();
      console.log(this.parameters4.info.filelist12);
    },
    //绿色施工子传父上传附件
    greenPorject(v, is) {
      console.log(v, is);
      this.parameters3.Upload = v
      this.lefttitlelist[3].isok = is
    },
    handenclosure(name, index, value) {
      let obj = {
        url: value.data.host + value.data.url,
        name: value.data.originalName
      }
      this.$set(this[name].enclosure, 'msg' + index, [obj])
      console.log(999, this[name].enclosure['msg' + index]);
      // this[name].enclosure['msg'+index] = [obj]

    },
    removeenclosure(name, index, value) {
      this.$set(this[name].enclosure, 'msg' + index)
    },
    //贵州省建筑业优秀项目经理 保存照片
    handleSuccessUpload(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
      let fileobj = {
        name: file.name,
        url: file.response.data.host + file.response.data.url
      }
      this.parameters2.candidate.msg15 = [fileobj];
    },
    //贵州省建筑业优秀项目经理 删除照片
    handleRemove(file) {
      delete this.parameters2.candidate.msg15
    },
    handleOnRemove1(file, fileList) {
      this.parameters4.info.filelist1 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove2(file, fileList) {
      this.parameters4.info.filelist2 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove3(file, fileList) {
      this.parameters4.info.filelist3 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove4(file, fileList) {
      this.parameters4.info.filelist4 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove5(file, fileList) {
      this.parameters4.info.filelist5 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove6(file, fileList) {
      this.parameters4.info.filelist6 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove7(file, fileList) {
      this.parameters4.info.filelist7 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove8(file, fileList) {
      this.parameters4.info.filelist8 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove9(file, fileList) {
      this.parameters4.info.filelist9 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove10(file, fileList) {
      this.parameters4.info.filelist10 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove11(file, fileList) {
      this.parameters4.info.filelist11 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove12(file, fileList) {
      console.log(file, fileList);
      this.parameters4.info.filelist12.pop(file)
    },
    //非空验证 参数：根据对象名，对象内有多少条属性，属性名
    noempty(obj, num, name) {
      var empty = true;
      console.log(num)
      console.log(obj)
      for (let i = 1; i <= num; i++) {
        if (obj[name + i] == "" || obj[name + i] == undefined) {
          console.log(obj[name + i])
          console.log(name )
          console.log(i)
          empty = false;
        }
      }
      console.log(empty)
      return empty;
    },
    //限制文件上传大小
    beforeAvatarUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      console.log(file);
      if (filesize > 100) {
        this.$message.error("上传文件不能大于100MB");
        return false;
      }
    },
    handlePreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    handlesuccess2(file, fileList) {
      this.Businesslicense = [fileList];
    },
    //竣工验收备案资料 有无上传文件
    isuploadshow2(v) {
      this.parameters.SupplementaryContent.is10 = v;
      if (v == "0") {
        this.parameters.SupplementaryContent.Acceptance_record = [];
      }
    },
    //有无上传文件
    isuploadshow(state, v) {
      v = v.toString();
      switch (state) {
        case "1":
          this.parameters.SupplementaryContent.is1 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is1arr = [];
          }
          break;
        case "2":
          this.parameters.SupplementaryContent.is2 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is2arr = [];
          }
          break;
        case "3":
          this.parameters.SupplementaryContent.is3 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is3arr = [];
          }
          break;
        case "4":
          this.parameters.SupplementaryContent.is4 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is4arr = [];
          }
          break;
        case "5":
          this.parameters.SupplementaryContent.is5 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is5arr = [];
          }
          break;
        case "6":
          this.parameters.SupplementaryContent.is6 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is6arr = [];
          }
          break;
        case "7":
          this.parameters.SupplementaryContent.is7 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is7arr = [];
          }
          break;
        case "8":
          this.parameters.SupplementaryContent.is8 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is8arr = [];
          }
          break;
        case "9":
          this.parameters.SupplementaryContent.is9 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is9arr = [];
          }
          break;
        case "10":
          this.parameters.SupplementaryContent.is10 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is10arr = [];
          }
          break;
        case "11":
          this.parameters.SupplementaryContent.is11 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is11arr = [];
          }
          break;
        case "12":
          this.parameters.SupplementaryContent.is12 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is12arr = [];
          }
          break;
        case "13":
          this.parameters.SupplementaryContent.is13 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is13arr = [];
          }
          break;
        case "14":
          this.parameters.SupplementaryContent.is14 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is14arr = [];
          }
          break;
        case "15":
          this.parameters.SupplementaryContent.is15 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is15arr = [];
          }
          break;
        case "16":
          this.parameters.SupplementaryContent.is16 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is16arr = [];
          }
          break;
        case "17":
          this.parameters.SupplementaryContent.is17 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is17arr = [];
          }
          break;
        case "18":
          this.parameters.SupplementaryContent.is18 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is18arr = [];
          }
          break;
        case "19":
          this.parameters.SupplementaryContent.is19 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is19arr = [];
          }
          break;
        case "20":
          this.parameters.SupplementaryContent.is20 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is20arr = [];
          }
          break;
        case "21":
          this.parameters.SupplementaryContent.is21 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is21arr = [];
          }
          break;
        case "22":
          this.parameters.SupplementaryContent.is22 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is22arr = [];
          }
          break;
      }
      console.log(this.parameters.SupplementaryContent);
    },
    //竣工验收备案资料 上传文件
    filechange2(v) {
      this.parameters.SupplementaryContent.is10arr = v;
    },
    //有无 上传文件
    filechange(res) {
      switch (res[0].title) {
        case "工程立项复批":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is1arr = res;
          } else {
            this.parameters.SupplementaryContent.is1arr = [];
          }
          break;
        case "土地使用证":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is2arr = res;
          } else {
            this.parameters.SupplementaryContent.is2arr = [];
          }

          break;
        case "建设工程规划许可证":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is3arr = res;
          } else {
            this.parameters.SupplementaryContent.is3arr = [];
          }
          break;
        case "工程创优策划书":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is4arr = res;
          } else {
            this.parameters.SupplementaryContent.is4arr = [];
          }
          break;
        case "工程施工图设计文件审查合格书或审批文件(电力工程按行业规定)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is5arr = res;
          } else {
            this.parameters.SupplementaryContent.is5arr = [];
          }
          break;
        case "工程施工合同":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is6arr = res;
          } else {
            this.parameters.SupplementaryContent.is6arr = [];
          }
          break;
        case "施工许可证或批准开工报告":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is7arr = res;
          } else {
            this.parameters.SupplementaryContent.is7arr = [];
          }
          break;
        case "建设工程消防验收意见书(涉及消防工程)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is8arr = res;
          } else {
            this.parameters.SupplementaryContent.is8arr = [];
          }
          break;
        case "工程“竣工验收报告”(交通工程提交“交工验收证书”,电力工程提交“投运备案证明书”,水利工程提交“工程合同完工验收文件”)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is9arr = res;
          } else {
            this.parameters.SupplementaryContent.is9arr = [];
          }
          break;
        case "“投入使用时间和使用效果证明”(建设单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is10arr = res;
          } else {
            this.parameters.SupplementaryContent.is10arr = [];
          }
          break;
        case "“建筑业10项新技术应用证明”(监理单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is11arr = res;
          } else {
            this.parameters.SupplementaryContent.is11arr = [];
          }
          break;
        case "工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”(建设单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is12arr = res;
          } else {
            this.parameters.SupplementaryContent.is12arr = [];
          }
          break;
        case "建筑业新技术应用示范工程或绿色施工示范工程证书":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is13arr = res;
          } else {
            this.parameters.SupplementaryContent.is13arr = [];
          }
          break;
        case "“贵州省建筑工程优质质量结构工程”评定文件(住宅工程、公共建筑工程、市政桥梁)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is14arr = res;
          } else {
            this.parameters.SupplementaryContent.is14arr = [];
          }
          break;
        case "“贵州省建筑安全文明施工样板工地”评定文件(住宅工程、公共建筑工程、市政园林工程)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is15arr = res;
          } else {
            this.parameters.SupplementaryContent.is15arr = [];
          }
          break;
        case "无质量安全事故承诺":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is16arr = res;
          } else {
            this.parameters.SupplementaryContent.is16arr = [];
          }
          break;
        case "无质量安全事故承诺补充材料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is17arr = res;
          } else {
            this.parameters.SupplementaryContent.is17arr = [];
          }
          break;
        case "无拖欠农民工工资承诺":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is18arr = res;
          } else {
            this.parameters.SupplementaryContent.is18arr = [];
          }
          break;
        case "无拖欠农民工工资承诺补充材料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is19arr = res;
          } else {
            this.parameters.SupplementaryContent.is19arr = [];
          }
          break;
        case "反映工程概况和质量状况的彩色照片15张":
          if (res[0].name) {
            if (!this.parameters.SupplementaryContent.is20arr) {
              this.parameters.SupplementaryContent.is20arr = [];
            }
            let bo = true;
            let i = 0;
            let j = this.parameters.SupplementaryContent.is20arr.length;
            for (; i < j; i++) {
              if (res[0].uid == this.parameters.SupplementaryContent.is20arr[i].uid) {
                bo = false;
                break;
              }
            }
            console.log(this.parameters.SupplementaryContent.is20arr)
            if (bo) {
              this.parameters.SupplementaryContent.is20arr.push(res[0]);
            }
          } else {
            this.parameters.SupplementaryContent.is20arr = [];
          }
          break;
        case "5分钟工程影像资料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is21arr = res;
          } else {
            this.parameters.SupplementaryContent.is21arr = [];
          }
          break;
        case "贵州省“黄果树杯”优质工程申报表（盖章后扫描件）":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is22arr = res;
          } else {
            this.parameters.SupplementaryContent.is22arr = [];
          }
          break;
      }
    },
    fileSplice(index) {
      // console.log(this.parameters.SupplementaryContent.is20arr)
      //   this.parameters.SupplementaryContent.is20arr.splice(index,1);
      //   console.log(this.parameters.SupplementaryContent.is20arr)
    },
    //建筑业10项新技术应用证明或绿色施工证明 新增5个以内上传文件
    newadd() {
      if (this.parameters.SupplementaryContent.certificate.length > 4) {
        return false;
      }
      this.parameters.SupplementaryContent.certificate.push({
        uploadinput: "",
        uploadlist: [],
      });
    },
    //删除申报登记表需补充内容的上传文件
    remove(type, index, fileList) {
      console.log('ok', type, index);
      if (type == 1) {

        this.parameters.SupplementaryContent.certificate.splice(index, 1);
      }
      if (type == 2) {
        this.parameters.SupplementaryContent.Architecture_msg2_file.splice(
          index,
          1
        );
      }
      if (type == 3) {
        this.parameters.SupplementaryContent.Architecture_msg3_file.splice(
          index,
          1
        );
      }
      console.log(this.parameters.SupplementaryContent.Architecture_msg3_file);
    },
    //建筑业10项新技术应用证明或绿色施工证明  文件上传
    handleSuccessImg(index, fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.certificate[index].uploadlist = [
        fileList.data,
      ];
      this.parameters.SupplementaryContent.certificate[index].title =
        "建筑业10项新技术应用证明或绿色施工证明";
      console.log(99, this.parameters.SupplementaryContent);
    },
    //省优质主体结构工程创优奖（房屋建筑、市政桥梁工程）  文件上传
    handleSuccessImg2(fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.Architecture_msg2_file = [
        fileList.data,
      ];
    },
    //省安全文明样板工地奖（房屋建筑、市政园林）  文件上传
    handleSuccessImg3(fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.Architecture_msg3_file = [
        fileList.data,
      ];
      console.log(this.parameters.SupplementaryContent.Architecture_msg3_file);
    },
    //承诺书上传
    onChange2(fileList) {
      // this.parameters.Recommendationform = fileList;
      this.$set(this.parameters, 'Recommendationform', fileList)
    },
    //选项 有无
    // changeTheme(e){
    //   console.log(e);
    // },
    //提交平台审核
    handleClick() {
      return;
    },
    async sumbit() {
      if (this.currentSubmit) {
        return;
      }
      this.currentSubmit = true;
      let data;
      for (let i = 0; i < this.lefttitlelist.length; i++) {
        if (!this.lefttitlelist[i].isok) {
          this.issumbit = false;
        }
      }
      let issubmit = this.issumbit;
      //setTimeout(() => {
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters2).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$message.error(err)
            })
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "省优工程“黄果树杯”":
          if (issubmit) {
            return Declare_modify(this.rId, this.$route.query.id, this.parameters).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "贵州省优秀施工企业":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters1).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "贵州省绿色施工示范工程":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters3).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;

        case "省级施工工法":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters4).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
      }
      //}, 500);

    },
    changeType(e) {
      console.log(e);
      let lefttitlelist = JSON.parse(JSON.stringify(this.lefttitlelist))
      lefttitlelist[1].isok = false;
      this.lefttitlelist = lefttitlelist;
      console.log(this.lefttitlelist[1])
      this.parameters4.info.type_of_major = "";
      if (e == "房屋建筑工程") {
        this.type_major_arr = this.type_major_arr1;
      }
      if (e == "土木工程") {
        this.type_major_arr = this.type_major_arr2;
      }
      if (e == "工业安装工程") {
        this.type_major_arr = this.type_major_arr3;
        this.type_major_arr3.forEach(item => {
          let key = item
          this.$set(this.form, key, [])
        });
        // this.$set(this.type_major_arr, 0, []);
      }
    },
    changeMajorType(e) {
      console.log(e);
      let lefttitlelist = JSON.parse(JSON.stringify(this.lefttitlelist))
      lefttitlelist[1].isok = true;
      this.lefttitlelist = lefttitlelist;
    },
    //保存草稿
    SaveDraftleft() {
      this.btnSaveStatus = true;
      let data;
      let lessonObj;
      let list = {};
      console.log(this.$route.query.title);
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          return SaveDraft(this.$route.query.id, this.parameters2).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
        case "省优工程“黄果树杯”":
          // for (const key in this.parameters.unitinfo[0]) {
          //   list[key] = this.parameters.unitinfo[0][key];
          // }
          // this.parameters.unitinfo[0] = list;
          return SaveDraft(this.$route.query.id, this.parameters).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
        case "贵州省优秀施工企业":
          return SaveDraft(this.$route.query.id, this.parameters1).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
        case "贵州省绿色施工示范工程":
          return SaveDraft(this.$route.query.id, this.parameters3).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
        case "新技术示范工程":
          return SaveDraft(this.$route.query.id, this.parameters6).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
        case "省级施工工法":
          return SaveDraft(this.$route.query.id, this.parameters4).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          });
      }
    },
    //在线预览
    async printPdf() {
      for (let i = 0; i < this.lefttitlelist.length; i++) {
        if (!this.lefttitlelist[i].isok) {
          this.issumbit = false;
        }
      }
      let data;
      let istrue = true;
      let count = 0;
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          data = await SaveDraft(this.$route.query.id, this.parameters2);
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters2)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "省优工程“黄果树杯”":
          for (const key in this.parameters.SupplementaryContent) {
            for (let i = 1; i <= 22; i++) {
              if (this.parameters.SupplementaryContent["is" + i] == "1") {
                if (this.parameters.SupplementaryContent["is" + i + "arr"].length < 1) {
                  istrue = false;
                }
              }
            }
          }
          console.log(this.parameters.SupplementaryContent);
          if (istrue) {
            console.log(this.parameters)
            data = await SaveDraft(this.$route.query.id, this.parameters);
            sessionStorage.setItem(
              "parameters",
              JSON.stringify(this.parameters)
            );
            this.$router.push(`/word_1?awardid=${this.$route.query.id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          } else {
            this.$message.error("请检查！有文件没有上传");
          }
          break;
        case "新技术示范工程":
          data = await SaveDraft(this.$route.query.id, this.parameters6);
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters3)
          );
          break;
        case "贵州省优秀施工企业":
          data = await SaveDraft(this.$route.query.id, this.parameters1);
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters1)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "贵州省绿色施工示范工程":
          data = await SaveDraft(this.$route.query.id, this.parameters3);
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters3)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "省级施工工法":
          data = await SaveDraft(this.$route.query.id, this.parameters4);
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters4)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
      }
    },
    //返回上一页
    backpage() {
      this.$router.go(-1);
    },
    //新增参建单位信息
    addnew() {
      this.parameters.unitinfo.push({
        Construction_content: "",
        Construction_proportion: "",
        Construction_workload: "",
        Qualification_level: "",
        Telephone: "",
        brief_introduction: "",
        codeyouzheng: "",
        guding_phone: "",
        leave: "",
        movephone1: "",
        name2: "",
        name3: "",
        name4: "",
        phone2: "",
        phone3: "",
        phoneaddress: "",
        postion: "",
        unitname: "",
        work_department: "",
      });
      this.lefttitlelist.splice(this.parameters.unitinfo.length, 0, {
        name:
          "参建单位信息" +
          (this.parameters.unitinfo.length - 1 == 0
            ? ""
            : this.parameters.unitinfo.length - 1),
        isok: false,
      });
    },
    //删除参建单位信息
    deleteform() {
      if (this.parameters.unitinfo.length == 1) {
        this.lefttitlelist.splice(1, 1);
        this.parameters.unitinfo = [];
        return false;
      }
      this.parameters.unitinfo.splice(this.parameters.unitinfo.length - 1, 1);
      this.lefttitlelist.splice(this.parameters.unitinfo.length + 1, 1);
    },
    deleteunit(states) {
      if (states == 1) {
        this.parameters4.unitarr.splice(this.parameters4.unitarr.length - 1, 1);
      }
      if (states == 2) {
        this.parameters4.Completed_byarr.splice(
          this.parameters4.Completed_byarr.length - 1,
          1
        );
      }
      if (states == 3) {
        console.log(33333)
        this.parameters4.info.author_names.splice(
          this.parameters4.info.author_names.length - 1,
          1
        );
      }
    },
    deleteuser(item) {
      this.parameters4.info.author_names.pop(item);
      this.$forceUpdate();
      this.author_sock_check();
    },
    add_author(event, item,index) {
      var tmp_item = item;
      tmp_item['name'] = event.target.value;
      this.parameters4.info.author_names[index] = tmp_item;
      this.author_sock_check();
    },
    author_sock_check() {
      this.lefttitlelist[3].isok = false;
      if (this.parameters4.info.author_names && this.parameters4.info.author_names.length > 0) {
        for (var i = 0; i < this.parameters4.info.author_names.length; i++) {
          if (this.parameters4.info.author_names[i].name.length > 0) {
            this.lefttitlelist[3].isok = true;
            return;
          }
        }
      }
    },
    addunit(states) {
      if (states == 1) {
        this.parameters4.unitarr.push({
          Approval_comments: "",
          address_code: "",
          name_phone: "",
          Office_telephone: "",
        });
      }
      if (states == 2) {
        this.parameters4.Completed_byarr.push({
          Approval_comments: "",
          address_code: "",
          name_phone: "",
          Office_telephone: "",
        });
      }
      if (states == 3) {
        this.upAuthor()
      }
    },
    upAuthor() {
      console.log("upAuthor")
      console.log(this.parameters4.info.author_names)
      if (typeof (this.parameters4.info.author_names) == "undefined") {
          this.parameters4.info.author_names = [{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          }];
        } else {

          let arr = this.parameters4.info.author_names;
          console.log(arr)
          console.log("arr1111")
          console.log(6 - arr.length)
          let newArr = Object.assign([], arr)

          for (let index = 0; index < (5 - arr.length); index++) {
            let data = {
              "name": "",
              "starttime": Math.floor((Math.random() * 1000) + 1),
            };
            newArr.push(data);
          }
          console.log(newArr)
          this.parameters4.info.author_names = newArr;
        }
        this.$forceUpdate();
        console.log(this.parameters4.info.author_names);
    },
    //左边导航列表点击
    scrollleft(name, id) {
      this.scrollnum(id);
    },
    //锚点滚动
    scrollnum(id) {
      document
        .querySelector(id)
        .scrollIntoView({ behavior: "smooth", block: "start" });

    },

    handleAdd(response, file, fileList) {
      this.fileList = fileList;
      this.ruleForm.business_license = response.data.host + response.data.url;
    },
    handleAdd2(response, file, fileList) {
      this.fileList2 = fileList;
      this.ruleForm.certifications = response.data.host + response.data.url;
    },
    handleAddhead_portrait(response, file, fileList) {
      this.head_portrait = fileList;
      this.ruleForm.head_portrait = response.data.host + response.data.url;
    },
    phandleRemove(file) {
      this.fileList = [];
      this.ruleForm.business_license = "";
    },
    phandleRemove2() {
      this.fileList2 = [];
      this.ruleForm.certifications = "";
    },
    phead_portraitremove(file) {
      console.log(file);
      this.head_portrait = [];
      this.ruleForm.head_portrait = "";
    },
    phandlePictureCardPreview(file) {
      console.log("ok");
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    phandleDownload(file) {
      console.log(file);
    },
    phandleExceed() {
      this.$message.warning(`请最多上传 ${this.limit} 个文件。`);
    },


  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  background: #eff3f8;

  .newadd {
    width: 100px;
    height: 36px;
    border: 1px solid #194abe;
    border-radius: 3px;
    text-align: center;
    line-height: 36px;
    color: #194abe;
    margin: 0 0 20px 20px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .my_form,
  .my_form2 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: visible;
    align-items: stretch;

    .form_title {
      background: #eaf0f6;
      width: 129px;
      min-width: 129px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      padding: 6px;
      box-sizing: border-box;
      color: #0c0d0f;
    }

    .form_tip {
      position: absolute;
      margin-left: 280px;
      color: red;
    }

    .uploadcertificate {
      align-self: center;
    }

    .form_upload {
      display: flex;
      flex-direction: column;
    }

    .uploadinput {
      width: 100%;
      background: #f5f8fb;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .uploadlist {
        display: flex;
        align-items: center;
        position: relative;

        .tipserror {
          width: 207px;
          height: 40px;
          background: #fcf4f4;
          border: 1px solid #ffc4c8;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          opacity: 1;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 40px;
          color: #7c828a;
          position: absolute;
          z-index: 999999999;
          top: -40px;
          left: 20px;

          img {
            width: 14px;
            height: 14px;
          }

          &::before {
            content: "";
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #ff989f;
          }
        }
      }

      .tipst {
        .tipserror {
          top: -26px;
        }
      }

      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;

        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }

      .input {
        width: 257px;
        display: flex;
        position: relative;
        display: flex;
        align-items: center;
        margin-left: 20px;

        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .form_content,
    .form_long,
    .form_choice {
      width: 300px;
      padding: 0px 6px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;

        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }

      .input {
        width: 257px;
        display: flex;
        position: relative;

        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .form_content {
      position: relative;

      .tipserror {
        width: 207px;
        height: 40px;
        background: #fcf4f4;
        border: 1px solid #ffc4c8;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 6px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 40px;
        color: #7c828a;
        position: absolute;
        z-index: 999999999;
        top: -36px;

        img {
          width: 14px;
          height: 14px;
        }

        &::before {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #ff989f;
        }
      }
    }

    .form_choice_long {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 729px;
      padding-left: 20px;
      box-sizing: border-box;
      background: #f5f8fb;
    }

    .form_long {
      width: 729px;

      input {
        width: 688px;
      }

      div {
        .el-upload-list {
          flex-wrap: wrap;

          li {
            width: 200px;
          }
        }
      }
    }

    .form_textarea {
      width: 729px;
      height: 188px;
      display: flex;
      background: #f5f8fb;
      flex-direction: column;
      justify-content: space-evenly;
      padding-left: 20px;

      textarea {
        width: 688px;
        height: 127px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 9px 15px;
        box-sizing: border-box;
        color: #000;

        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
    }

    .uploadimg {
      width: 729px;
      padding: 20px;
      background: #f5f8fb;
      box-sizing: border-box;
    }

    .Downinpustyle {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      background: #f5f8fb;

      .nejje {
        color: #194abe !important;
      }
    }

    .upload-demo {
      width: 729px;
      padding-left: 20px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: auto;

      .el-upload__tip {
        margin-left: 10px;
      }
    }
  }

  .my_formmin,
  .my_form2min {
    width: 286px;

    .form_title {
      width: 86px;
      min-width: 86px;
      padding: 20px 5px;
    }

    .form_content {
      width: 200px;
      display: flex;
      flex-direction: column;
    }

    input,
    .input {
      width: 171px !important;
      margin: 5px 0;
    }
  }

  .my_form {}

  .my_form2 {
    .form_title {
      background: #f5f8fb;
    }

    .form_content,
    .form_long,
    .form_textarea,
    .form_choice,
    .form_choice_long,
    .upload-demo,
    .Downinpustyle,
    .uploadinput {
      background: #fbfdff;
    }

    .uploadcertificate {
      align-self: center;
    }

    .form_upload {
      display: flex;
      flex-direction: column;
    }
  }

  .form-upload-div {
    display: flex;
    padding-right: 20px;
    padding-right: 20px;

    .action_upload {
      color: #2f67d1;
    }
  }

  //   顶部title样式
  .header_title {
    width: 100%;
    margin: 0 auto;
    height: 58px;
    background: #ffffff;
    box-shadow: 0px 6px 12px rgba(0, 17, 58, 0.06);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .header_center {
      width: 1200px;
      margin: 0 auto;
      height: 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 29px;
        color: #0c0d0f;

        span {
          font-size: 22px;
          line-height: 32px;
          color: #194abe;
        }
      }

      .back_page {
        cursor: pointer;
        width: 124px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #c8cdd5;
        opacity: 1;
        border-radius: 6px;
        line-height: 36px;
        color: #7c828a;
      }
    }
  }

  // form_box样式
  .form_box {
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 78px;
    display: flex;
    justify-content: space-between;

    .tips {
      width: 20px;
      height: 20px;
    }

    .nav_left,
    .form_right {
      border-radius: 6px;
    }

    .nav_left {
      position: fixed;
      width: 268px;

      .nav_title,
      .nav_list {
        background: #ffffff;
        width: 100%;
        text-align: start;
        padding: 0 16px;
        box-sizing: border-box;
        cursor: pointer;
      }

      .nav_title {
        height: 53.5px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 53.5px;
        color: #0c0d0f;
        border-radius: 6px 6px 0px 0px;
      }

      .nav_list {
        margin-top: 2px;
        height: 350px;
        overflow-y: scroll;
        overflow-x: hidden;
        border-radius: 0px 0px 6px 6px;

        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background-color: #b7c8f1;
        }

        .list {
          width: 100%;
          height: 57px;
          border-bottom: 1px dashed #d4dbdd;
          display: flex;
          align-items: center;

          p {
            margin-left: 13px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }

      .preview {
        margin-top: 17px;
        width: 100%;
        height: 201px;
        padding: 16px;
        box-sizing: border-box;
        background: white;
        border-radius: 0px 0px 6px 6px;

        .preservation,
        .online,
        .sumbit {
          cursor: pointer;
          width: 236px;
          height: 50px;
          background: #ffffff;
          opacity: 1;
          border-radius: 4px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }

        .blue {
          background: #194abe !important;
        }

        .preservation {
          border: 1px solid #194abe;
          color: #194abe;
        }

        .online {
          margin: 10px 0;
          border: 1px solid #1abf98;
          color: #1abf98;
        }

        .sumbit {
          background: #d4dbdd;
          border-radius: 4px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 27px;
          color: #ffffff;

          img {
            width: 18px;
            height: 14px;
          }
        }
      }
    }

    .form_right {
      margin-left: 300px;
      width: 918px;

      .flex {
        display: flex;
      }

      .flex-direction {
        flex-direction: column;
      }

      .form_1 {
        width: 100%;
        background: #ffffff;
        padding: 35px 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        border-radius: 6px;

        .form_dec {
          text-align: left;
          margin-top: 20px;
        }

        .border {
          border-top: 1px dashed #9fa5ae;
          margin: 20px 0;
        }

        .bord {
          margin-top: 11px;
          width: 858px;
          height: 0px;
          border: 1px solid #194abe;
          position: relative;

          img {
            width: 11px;
            height: 6px;
            position: absolute;
            top: -6px;
            left: 37px;
          }
        }

        .newlybuild {
          margin: 0 auto;
          cursor: pointer;
          width: 221px;
          height: 36px;
          border: 2px solid #194abe;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 16px;
            height: 16px;
            margin-right: 7px;
          }

          p {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 14px;
            color: #194abe;
          }
        }

        .form_box_content {
          width: 100%;
          margin-top: 20px;

          .form_title {
            box-sizing: border-box;
            text-align: start;
            display: flex;
            align-items: center;

            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 20px;
              color: #0c0d0f;
            }

            .delete_icon {
              cursor: pointer;
              margin-left: 10px;
              width: 61px;
              height: 25px;
              background: #ffffff;
              border: 1px solid #f9656f;
              opacity: 1;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: space-evenly;

              img {
                width: 13px;
                height: 14px;
              }

              p {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                line-height: 20px;
                color: #f9656f;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.el-upload-list {
}

.el-upload-list__item {
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>


<style lang="less">
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;

  .el-tabs__item,
  .is-active {
    color: #7c828a;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item.is-active {
    color: #194abe;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item:hover {
    color: #194abe;
  }

  .el-tabs__active-bar {
    background-color: #194abe;
  }
}

.el-form-item__error {
  margin-left: 140px;
}

.el-form-item__label {
  min-width: 300px;
}

.el-form-item__content {
  text-align: left;
}

.block-solid {
  margin-top: 70px;
}
</style>
<style scoped lang="less">
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-red-border {
  width: 100%;
  border-top: 2px solid #e51725;
  display: flex;
  justify-content: center;
  padding-top: 37px;
  margin-top: 40px;
  .btn-give_up {
    cursor: pointer;
    width: 189px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #194abe;
  }
  .btn-modify {
    cursor: pointer;
    width: 189px;
    height: 50px;
    background: #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 14px;
      margin-right: 10px;
    }
    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 27px;
      color: #ffffff;
    }
  }
}
.demo-ruleForm {
  width: 100%;
  margin: 30px 0;
  text-align: center;
  .inpyabeb {
    width: 50%;
  }
}
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
    div{
      display: flex;
      align-items: center;
      /deep/.el-upload-list{
        margin: 0 !important;
		flex-wrap: wrap;
		li{
			width: 200px;
			margin-left: 10px;
		}
      }
    }
  }
  .form_long-1{
    display: flex;
    align-items: left;
    justify-content: left!important;;
	padding-left: 30px!important;
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 729px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form {
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle {
    background: #fbfdff;
  }
}
.from-div{
	padding-bottom: 12px;
}
.form-lable{
	width: 100%;
    display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 8px;
	.left{
		font-size: 16px;
		font-weight: bolder;
	}
	.right{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		border:1px solid #F9656F;
		border-radius: 5px;
		padding: 2px 8px;
		margin-left: 15px;
		img{
			width: 15px;
			height: 15px;
		}
		.delete-txt{
			font-size: 14px;
			font-weight: bolder;
			color: #F9656F;
			margin-left: 5px;
		}
	}
}
.el-upload-list {
	flex-wrap: wrap;
	margin: 0;
	padding: 0;
	list-style: none;
}
</s
